import React from 'react';
import '../../styles/components/ModalChangeTheme.scss';
import { language } from '../../services/LanguageService';
import { tracking } from '../../services/TrackingService';
import { AsperaWrapper } from '../AsperaWrapper';
import { TileGroup, RadioTile, getIcon } from '../Carbon';
/**
 * React Component
 * @remarks this modal is not exported and is used only for Aspera Starter internal system.
 *
 * The ModalChangeTheme provides the modal for changing the theme.
 *
 * @example
 * ```javascript
 * <ModalChangeTheme />
 * ```
 */
export class ModalChangeTheme extends React.Component {
    constructor() {
        super(...arguments);
        this.changeTheme = (theme) => {
            tracking.themeChoice = theme;
        };
    }
    componentWillUnmount() {
        const { modalClose } = this.props;
        modalClose({});
    }
    render() {
        const { className } = this.props;
        const options = [
            {
                id: 'NONE',
                icon: 'Devices',
                name: language.get('header.systemDefault'),
            },
            {
                id: 'DARK',
                icon: 'Moon',
                name: language.get('header.darkMode'),
            },
            {
                id: 'LIGHT',
                icon: 'Sun',
                name: language.get('header.lightMode'),
            },
        ];
        return (React.createElement(AsperaWrapper, { className: `modal-body-change-theme ${className ? className : ''}` },
            React.createElement(TileGroup, { valueSelected: tracking.themeChoice, legend: language.get('header.theme'), name: "tile-group", onChange: this.changeTheme }, options.map((option, index) => React.createElement(RadioTile, { key: index, id: `theme-${option.id}`, name: option.id, tabIndex: 0, value: option.id, className: "cds--tile--light" },
                React.createElement("div", { className: "modal-body-change-theme--option" },
                    getIcon(option.icon, 20, { className: 'modal-body-change-theme--icon' }),
                    React.createElement("div", { className: "modal-body-change-theme--text" }, option.name)))))));
    }
}
